module.exports = __webpack_public_path__ + "0a6b0b9dfa49a30c51b30554fdba823d.svg";